/**
 * Custom BarChartComponent - Override Component
 * Auto generated overrides from shared library
 */
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarChartComponent as ParentBarChartComponent } from '@shared-lib/chart-components/bar-chart/bar-chart.component';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent extends ParentBarChartComponent {
  // Constructor is inherited from parent to avoid dependency injection issues

  protected override loadAndRenderChart(filters?: any): any {
    // TODO: Add your custom logic here
    return super.loadAndRenderChart(filters);
  }

  protected override renderChart(chartData?: any): any {
    // TODO: Add your custom logic here
    return super.renderChart(chartData);
  }

      
  
  
  protected override addResizeListener(): any {
    // TODO: Add your custom logic here
    return super.addResizeListener();
  }
}
